import { useQuery } from '@tanstack/react-query';
import PracticeService from '../../../services/practice-service';

// The filters are part of the key so differently filtered lists do not share
// a cache entry. Invalidating ['practices'] still refreshes every list.
export const practiceListKey = (filters: Record<string, unknown>) => [
  'practices',
  'list',
  filters,
];

const useGetPractices = (filters: any, enabled?: boolean) => {
  return useQuery({
    queryKey: practiceListKey(filters),
    queryFn: () =>
      PracticeService.getPractices({ filters: { page: 1, ...filters } }),
    enabled: enabled ?? true,
  });
};

export default useGetPractices;
